/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownTransform } from '../../CrownTransform';
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
let Shape3DCone = class Shape3DCone extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        CrownTransform.copyMatrix(shape.pose, this);
        const geometry = Solids.createCone(shape.radius, shape.height);
        geometry.rotateX(Math.PI / 2);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide });
        this.addOutline(geometry, decoration);
    }
    format() {
        const { source, t, r, s, Matrix } = this.transformPose();
        return {
            radius: s.x * source.radius,
            height: s.z * source.height,
            pose: {
                Type: r.length() > 0 ? 'RIGID' : t.length() > 0 ? 'TRANSLATION' : 'IDENTITY',
                Matrix,
            },
        };
    }
};
Shape3DCone = tslib_1.__decorate([
    Shape('Shape3D.Cone'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DCone);
export { Shape3DCone };
//# sourceMappingURL=Shape3DCone.js.map